import selectedIcon from '@/assets/icons/selected-v.svg';
import styles from './ChooseSupplier.module.scss';

interface ProjectListItemProps {
  name: string;
  /** The project's type ("כתיבת ספר תורה"...), shown small beside the name. */
  typeName?: string | null;
  isSelected: boolean;
  onClick: () => void;
}

/**
 * One approved project in the fund-expense request's "בחירת מיזם" step (HAT-1105). Shaped like the
 * supplier row beside it, so the two steps read as one list in two parts; a radio, because exactly
 * one project is chosen.
 */
const ProjectListItem = ({ name, typeName, isSelected, onClick }: ProjectListItemProps) => (
  <div
    role="radio"
    aria-checked={isSelected}
    tabIndex={0}
    className={`${styles.supplierListItem} ${isSelected ? styles.selected : ''}`}
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
  >
    <div className={`${styles.innerContent} ${isSelected ? styles.selected : ''}`}>
      <div className={styles.details}>
        <span className="body-lr-regular text-(--font-body-1) overflow-hidden text-ellipsis whitespace-nowrap">{name}</span>
        {typeName && <span className="body-sm-regular text-(--font-body-2)">{typeName}</span>}
      </div>
      {isSelected && <img src={selectedIcon} alt="" aria-hidden="true" width={20} height={20} />}
    </div>
  </div>
);

export default ProjectListItem;
